export const news = [
  {
    id: "news-anyong-season2",
    title: "《暗涌》第二季正式官宣开机，原班人马回归",
    category: "发行动态",
    date: "2025-10-12",
    summary:
      "出品方确认《暗涌》第二季已进入拍摄阶段，故事将从第一季结尾的潮汐表继续展开，主创称新一季会更聚焦人物的选择而非案件本身。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20film%20crew%20silhouette%20on%20a%20foggy%20harbor%20pier%20at%20dawn%2C%20camera%20on%20tripod%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20atmospheric%20film%20grain%2C%20no%20text&width=1200&height=675&seq=news-anyong-s2&orientation=landscape",
    author: "编辑部 · 林一",
    content: [
      "10 月 11 日，剧集《暗涌》出品方在官方渠道确认，第二季已于本月正式开机，第一季的核心主创将全部回归，包括导演沈聿与编剧团队。",
      "据现场工作人员透露，第二季的开场会直接衔接第一季最后一集的码头场景，但时间线会向前跳跃两年。制片人表示：「我们不想再重复一次同样的悬念，新一季的重点是人物如何在真相之后继续生活。」",
      "关于观众最关心的感情线走向，主创没有给出明确答复，只表示第一季留下的三处伏笔会在新一季的前四集内全部回收。该剧预计于 2026 年下半年与观众见面。",
    ],
    relatedIds: ["news-changye-rain", "news-baita-ending"],
  },
  {
    id: "news-changye-rain",
    title: "幕后揭秘：《长夜将明》那场八分钟雨夜长镜头是怎么拍的",
    category: "幕后揭秘",
    date: "2025-10-08",
    summary:
      "摄影指导首次公开拍摄细节：三台稳定器、两条街的雨棚、以及一次几乎失败的调度，成就了整部剧被讨论最多的段落。",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20at%20night%20in%20artificial%20rain%2C%20lighting%20rigs%20and%20wet%20street%2C%20deep%20navy%20shadows%20with%20amber%20practical%20lights%2C%20documentary%20cinematic%20still%2C%20no%20text&width=1200&height=675&seq=news-changye-rain&orientation=landscape",
    author: "编辑部 · 周迟",
    content: [
      "《长夜将明》第三集有一段长达八分钟的雨夜跟拍，镜头始终贴在主角背后，从巷口一直走到天桥。这段戏在社交平台上被反复拆解，也成了该剧的视觉标志。",
      "摄影指导在采访中透露，这场戏实际拍摄了两天，共 17 条。「最难的不是雨，是我们要让观众看不到任何穿帮的灯。」团队沿街布置了两百多个隐藏光源，全部藏在雨棚与卷帘门缝隙里。",
      "至于为什么坚持一镜到底，导演韩牧的解释很朴素：「如果剪开，观众就会松一口气。我不想让他们松这口气。」",
    ],
    relatedIds: ["news-autumn-lineup", "news-anyong-season2"],
  },
  {
    id: "news-baita-ending",
    title: "《白塔之下》大结局解析：三个容易被忽略的细节",
    category: "影视新闻",
    date: "2025-10-03",
    summary:
      "大结局播出后讨论度持续走高。我们把镜头语言、声音设计和对白里的三处伏笔重新梳理了一遍，结局远比看上去更冷。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20dark%20luxury%20apartment%20corridor%20with%20one%20warm%20lit%20doorway%2C%20cold%20white%20marble%2C%20unsettling%20symmetry%2C%20deep%20shadow%2C%20no%20text&width=1200&height=675&seq=news-baita-ending&orientation=landscape",
    author: "编辑部 · 沈禾",
    content: [
      "《白塔之下》用十四集讲了一个家庭如何维护体面，最后一集却只用了几分钟就把这层体面拆掉。很多观众觉得结局「太安静」，但安静本身正是这部剧的答案。",
      "第一个细节是灯。全剧出现过 11 次走廊灯，只有最后一次是被人主动关掉的。第二个细节是电梯提示音，它在结局里第一次缺失。第三个细节是佣人房的门——它从第一集就开着，最后一集才被关上。",
      "这些细节共同指向一个结论：这座塔没有倒塌，它只是被住在里面的人放弃了。导演郑瑞渊在采访中说：「我不相信一场爆炸能解决结构性的问题，所以我把声音关掉了。」",
    ],
    relatedIds: ["news-anyong-season2", "news-guixu-art"],
  },
  {
    id: "news-autumn-lineup",
    title: "秋季档剧集片单：12 部值得放进待看列表的作品",
    category: "影视新闻",
    date: "2025-09-28",
    summary:
      "从古装探案到都市情感，本季度的剧集类型分布相当均衡。我们按题材整理了一份可以直接收藏的片单。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20film%20magazines%20and%20notebooks%20on%20a%20warm%20wooden%20desk%2C%20autumn%20afternoon%20light%2C%20cream%20and%20amber%20tones%2C%20editorial%20photography%2C%20no%20text&width=1200&height=675&seq=news-autumn-lineup&orientation=landscape",
    author: "编辑部 · 许南",
    content: [
      "今年的秋季档有一个明显特点：短剧变多了。十到十四集的体量逐渐成为主流，这让很多故事得以保持紧凑。",
      "古装方面，《长安夜行》以单元探案的结构获得了不错的口碑；都市情感线上，《春日迟迟》用极慢的节奏讲了一个成年人的故事，评价两极但值得一看。",
      "如果你只想挑一部，我们仍然推荐《白塔之下》。它不靠反转取胜，而是靠对日常细节的耐心观察，这在当下的剧集市场里相当少见。",
    ],
    relatedIds: ["news-changye-rain", "news-wuzhong-award"],
  },
  {
    id: "news-guixu-art",
    title: "《归墟》美术团队访谈：我们想造一座没有答案的废墟",
    category: "幕后揭秘",
    date: "2025-09-19",
    summary:
      "从石阶的磨损方向到经幡的飘动频率，美术团队用一套近乎苛刻的规则，构建了今年最有辨识度的奇幻场景。",
    cover:
      "https://readdy.ai/api/search-image?query=Concept%20art%20of%20ancient%20stone%20ruins%20above%20dark%20water%20with%20mist%2C%20indigo%20and%20antique%20gold%20palette%2C%20painterly%20oriental%20fantasy%20environment%2C%20no%20text&width=1200&height=675&seq=news-guixu-art&orientation=landscape",
    author: "编辑部 · 顾青",
    content: [
      "《归墟》的场景几乎全部在棚内完成，但观众很难察觉。美术指导说，他们的核心原则是「不要让它看起来像仙境」。",
      "石阶的磨损方向经过专门设计：所有台阶都朝向水面，暗示这里的人曾经不断往外走。经幡的飘动频率则被要求与演员的呼吸同步，以制造一种轻微的失控感。",
      "团队还刻意保留了搭建痕迹，比如木结构的接缝。「废墟不应该是干净的，它必须让人相信这里真的有人生活过。」",
    ],
    relatedIds: ["news-baita-ending", "news-autumn-lineup"],
  },
  {
    id: "news-wuzhong-award",
    title: "《雾中列车》入围国际剧集奖最佳限定剧",
    category: "发行动态",
    date: "2025-09-11",
    summary:
      "八集限定剧《雾中列车》获得最佳限定剧与最佳摄影两项提名，成为本年度唯一入围的亚洲合拍作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20steam%20train%20crossing%20misty%20moor%20at%20dusk%20with%20glowing%20carriage%20windows%2C%20deep%20forest%20green%20and%20amber%20palette%2C%20cinematic%20atmospheric%20wide%20shot%2C%20no%20text&width=1200&height=675&seq=news-wuzhong-award&orientation=landscape",
    author: "编辑部 · 陈默",
    content: [
      "组委会于本周公布入围名单，《雾中列车》获得最佳限定剧与最佳摄影两项提名。该剧以密闭空间推理和克制的英式叙事获得评论界好评。",
      "导演艾略特·哈里斯在回应中表示，剧组最初只打算做成一部电视电影，是制片方坚持扩写成八集。「现在回头看，那八个小时的呼吸是必要的。」",
      "颁奖礼将于下月举行。无论结果如何，这部剧已经确认会推出 4K 修复版本。",
    ],
    relatedIds: ["news-autumn-lineup", "news-changye-rain"],
  },
  {
    id: "news-qunshan-oral",
    title: "从《群山回响》看年代剧的口述史叙事",
    category: "幕后揭秘",
    date: "2025-08-30",
    summary:
      "四十集的长度里没有大事件，却让人记住了每一个名字。我们和编剧聊了聊「口述史」如何变成一种剧作方法。",
    cover:
      "https://readdy.ai/api/search-image?query=Terraced%20mountain%20village%20at%20dawn%2C%20stone%20schoolhouse%20with%20warm%20window%20light%2C%20muted%20earth%20green%20and%20ochre%20palette%2C%20documentary%20cinematic%20still%2C%20no%20text&width=1200&height=675&seq=news-qunshan-oral&orientation=landscape",
    author: "编辑部 · 何秀",
    content: [
      "《群山回响》的编剧团队在开拍前做了两年田野采访，收集了七十多位乡村教师的录音。这些素材最终只有很小一部分进入剧本，但决定了整部剧的语气。",
      "「我们定了一条规矩：不写奇迹。」编剧说，「所有感人的地方都必须来自具体的生活细节，比如粉笔灰、比如一双补了三次的鞋。」",
      "这种克制让剧集在播出两年后仍然被反复提起。它证明年代剧不必依赖强情节，也可以靠真实感留住观众。",
    ],
    relatedIds: ["news-autumn-lineup", "news-guixu-art"],
  },
  {
    id: "news-chunri-ost",
    title: "《春日迟迟》原声带上线，收录 18 首配乐",
    category: "发行动态",
    date: "2025-08-21",
    summary:
      "由室内乐团录制的原声专辑正式上线，包含主题曲与 17 首配乐，其中三首为剧中未使用的弃用版本。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20sunlit%20room%20with%20a%20vintage%20record%20player%20and%20sheet%20music%2C%20cream%20and%20amber%20tones%2C%20soft%20afternoon%20light%2C%20editorial%20still%20life%20photography%2C%20no%20text&width=1200&height=675&seq=news-chunri-ost&orientation=landscape",
    author: "编辑部 · 苏禾",
    content: [
      "《春日迟迟》的原声专辑今日上线，共收录 18 首作品，由一支十二人室内乐团完成录制。",
      "作曲在介绍中提到，整张专辑的基调是「不打扰」：旋律尽量简单，留出大量空白，让对白和呼吸成为主角。专辑最后三首是弃用版本，反而更能听出创作的犹豫。",
      "其中主题曲在剧中只出现过两次，一次在第三集的开头，一次在大结局的阳台段落。这种克制使用，让旋律在观众记忆里停留得更久。",
    ],
    relatedIds: ["news-anyong-season2", "news-autumn-lineup"],
  },
];